import { FormattedMessage } from 'react-intl'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'

function ErrorState({ messageId }) {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Alert severity="error">
          <FormattedMessage id={messageId} />
        </Alert>
      </Box>
    </Container>
  )
}

export default ErrorState
